import * as React from 'react';
import { resolve } from 'inversify-react';

import { RoleUserEditorView } from 'src/app/general/roles/parts/role-user-editor.view';
import { CardController } from 'src/app/shared/card.controller';
import { RoleEditorController } from 'src/app/general/roles/list/parts/role-editor.controller';

interface RoleUserEditorControllerProps extends ComponentViewProps<UserItem> {
	title?: string;
	mode: ControlMode;
	roles: DataSet<UserRoleSummary>;
	createNewUserRole: (roleId: number) => Promise<UserRoleSummary>;
	onCancel: () => Promise<any>;
}

export class RoleUserEditorController extends React.Component<RoleUserEditorControllerProps, {}> {
	constructor(props: Readonly<RoleUserEditorControllerProps>) {
		super(props);
	}

	render(): JSX.Element {
		return (
			<CardController
				className="card-borderless"
				mode={this.props.mode}
				icon="user"
				title={this.props.title}>
				<RoleUserEditorView
					mode={this.props.mode}
					model={this.props.roles}
					setBusy={this.props.setBusy}
					onCancel={this.props.onCancel}
					createNewUserRole={this.props.createNewUserRole}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/parts/role-user-editor.controller.tsx